const CONSUMER_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.com.au',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'mail.com',
  'yandex.com',
  'gmx.com',
  'msn.com',
]);

const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function extractEmailDomain(email: string) {
  const normalized = email.trim().toLowerCase();
  const at = normalized.lastIndexOf('@');
  if (at < 1) return '';
  return normalized.slice(at + 1);
}

/** Corporate / institutional domain — blocks common personal mail providers. */
export function isInstitutionalEmail(email: string) {
  const trimmed = email.trim();
  if (!EMAIL_FORMAT.test(trimmed)) return false;

  const domain = extractEmailDomain(trimmed);
  if (!domain || domain.includes('..')) return false;
  if (CONSUMER_EMAIL_DOMAINS.has(domain)) return false;

  const labels = domain.split('.');
  if (labels.length < 2) return false;
  if (labels.some((label) => !label || label.length > 63)) return false;

  return true;
}

export const INSTITUTIONAL_EMAIL_HINT =
  'Use your organisation\'s authorised corporate email domain (not personal webmail).';
